/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer__Auctions__Item_2Inputs */

const en_footer__auctions__item_2 = /** @type {(inputs: Footer__Auctions__Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works`)
};

/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Footer__Auctions__Item_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer__auctions__item_2 = /** @type {((inputs?: Footer__Auctions__Item_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer__Auctions__Item_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer__auctions__item_2(inputs)
});